"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableSubplaceParamsProvider = exports.constructNewSearchWithClearedColumnSelection = exports.constructNewSearchForColumnSelection = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var SiteUrls_1 = require("@tableau/shared-urls/lib/src/SiteUrls");
var React = require("react");
var reselect_1 = require("reselect");
function constructNewSearchForColumnSelection(search, columnId) {
    var paramValuesMap = data_catalog_shared_1.searchToParamValuesMap(search);
    var columns = paramValuesMap[SiteUrls_1.CatalogUrlParamKeys.column];
    if (columns && columns.indexOf(columnId) >= 0) {
        data_catalog_shared_1.removeParamValue(paramValuesMap, SiteUrls_1.CatalogUrlParamKeys.column, columnId);
    }
    else {
        data_catalog_shared_1.setParamValues(paramValuesMap, SiteUrls_1.CatalogUrlParamKeys.column, [columnId]);
    }
    return data_catalog_shared_1.paramValuesMapToSearch(paramValuesMap);
}
exports.constructNewSearchForColumnSelection = constructNewSearchForColumnSelection;
function constructNewSearchWithClearedColumnSelection(search) {
    var paramValuesMap = data_catalog_shared_1.searchToParamValuesMap(search);
    var columns = paramValuesMap[SiteUrls_1.CatalogUrlParamKeys.column];
    if (columns) {
        data_catalog_shared_1.setParamValues(paramValuesMap, SiteUrls_1.CatalogUrlParamKeys.column, []);
    }
    return data_catalog_shared_1.paramValuesMapToSearch(paramValuesMap);
}
exports.constructNewSearchWithClearedColumnSelection = constructNewSearchWithClearedColumnSelection;
var TableSubplaceParamsProvider = /** @class */ (function (_super) {
    __extends(TableSubplaceParamsProvider, _super);
    function TableSubplaceParamsProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableSubplaceParamsProvider.prototype.render = function () {
        var _this = this;
        return (React.createElement(data_catalog_shared_1.UrlSearchProvider, null, function (urlSearch) {
            return React.createElement(TableSubplaceParamsProviderInternal, { urlSearch: urlSearch }, _this.props.children);
        }));
    };
    return TableSubplaceParamsProvider;
}(React.Component));
exports.TableSubplaceParamsProvider = TableSubplaceParamsProvider;
var TableSubplaceParamsProviderInternal = /** @class */ (function (_super) {
    __extends(TableSubplaceParamsProviderInternal, _super);
    function TableSubplaceParamsProviderInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tslint:disable-next-line: typedef
        _this.memoizedGetFirstParamValueAsSet = reselect_1.defaultMemoize(data_catalog_shared_1.getFirstParamValueAsSet);
        _this.clearColumnSelection = function () {
            var urlSearch = _this.props.urlSearch;
            var newSearchWithClearedColumnSelection = constructNewSearchWithClearedColumnSelection(urlSearch.value);
            urlSearch.update(newSearchWithClearedColumnSelection);
        };
        _this.updateColumnSelection = function (columnId) {
            var urlSearch = _this.props.urlSearch;
            var newSearch = constructNewSearchForColumnSelection(urlSearch.value, columnId);
            urlSearch.update(newSearch);
        };
        return _this;
    }
    TableSubplaceParamsProviderInternal.prototype.render = function () {
        return this.props.children({
            urlSearchValue: this.props.urlSearch.value,
            selectedColumns: this.memoizedGetFirstParamValueAsSet(this.props.urlSearch.value, SiteUrls_1.CatalogUrlParamKeys.column),
            updateColumnSelection: this.updateColumnSelection,
            clearColumnSelection: this.clearColumnSelection,
        });
    };
    return TableSubplaceParamsProviderInternal;
}(React.Component));
//# sourceMappingURL=TableSubplaceParamsProvider.js.map